import { render, staticRenderFns } from "./ReviewClientResponse.vue?vue&type=template&id=0c40a930&"
import script from "./ReviewClientResponse.vue?vue&type=script&lang=js&"
export * from "./ReviewClientResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports